import React from 'react';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import LoaderLogo from './files/loader.json';
import LoaderLogoTitle from './files/loader-title.json';
/**
 * Loader Component
 * @param title {boolean} Loader With Title
 */
const Loader = ({ title, testId, ...others }) => {
    return (React.createElement(Lottie, { play: true, ...others, "data-testid": testId, style: { width: title ? '120px' : '80px' }, animationData: title ? LoaderLogoTitle : LoaderLogo, loop: true }));
};
export default Loader;
//# sourceMappingURL=Loader.js.map